import React from "react";
import PropTypes from "prop-types";

function Section({ style, children }) {
  if (!children) return null;

  return (
    <div
      style={{
        border: "1px solid #C9C9C9",
        borderRadius: "6px",
        padding: "40px",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

Section.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node,
};

Section.defaultProps = {
  style: {},
  children: null,
};

export default Section;
